import axios from 'axios';
import toastr from 'toastr';

// const devUrl = 'http://localhost:3000';
// const prodUrl = process.env.REACT_APP_API_URL;

// export const baseURL =
// process.env.NODE_ENV !== 'production' ? devUrl : prodUrl;

export const baseURL = process.env.REACT_APP_API_URL || "http://localhost:9090" ;

axios.defaults.headers.post['Content-Type'] = 'application/json';

// VERSION MARKER - Check console to verify new code is loaded
console.log('🔧 AUTH FIX LOADED - Version: 2024-11-11-00:57 - Authorization header will be added to all requests');
console.log('If you see this message, the updated JavaScript has loaded successfully!');



export const INSTANCE = axios.create({
  baseURL,
});

// Only set RocketChat headers if they exist
const rcToken = localStorage.getItem('rcToken');
const rcUserId = localStorage.getItem('rcUserId');
if (rcToken && rcToken !== 'null') {
  INSTANCE.defaults.headers['X-Auth-Token'] = rcToken;
}
if (rcUserId && rcUserId !== 'null') {
  INSTANCE.defaults.headers['X-User-Id'] = rcUserId;
}

/**
 * Request interceptor to add Authorization header with Bearer token
 */
INSTANCE.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');

    // Version marker to verify new code is loaded
    if (config.url?.includes('chatroom')) {
      console.log('[AUTH FIX v2024-11-11] Setting Authorization header for chatroom request');
    }

    if (token && token !== 'null') {
      // For axios, we need to set headers using bracket notation
      // This works for both AxiosHeaders and plain objects
      if (!config.headers) {
        config.headers = {};
      }
      config.headers['Authorization'] = `Bearer ${token}`;

      // Also try setting it via the common property
      if (config.headers.common) {
        config.headers.common['Authorization'] = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Clear all authentication data and redirect to login
 */
const clearAuthAndRedirect = (message: string = 'Session expired. Please log in again.') => {
  console.log('Clearing auth and redirecting to login:', message);

  // Clear all localStorage
  localStorage.clear();

  // Clear sessionStorage
  sessionStorage.clear();

  // Show error message
  toastr.error(message);

  // Redirect to login with current path for return
  const currentPath = window.location.pathname + window.location.search;
  const redirectParam = currentPath !== '/login' ? `?redirect=${encodeURIComponent(currentPath)}` : '';

  setTimeout(() => {
    window.location.href = `/login${redirectParam}`;
  }, 500);
};

const createAxiosResponseInterceptor = () => {
  const interceptor = INSTANCE.interceptors.response.use(
    (response) => response,
    (error) => {
      // Handle network errors
      if (!error.response) {
        console.error('Network error:', error.message);
        // Don't redirect on network errors - might be temporary
        return Promise.reject(error);
      }

      const status = error?.response?.status;

      // Handle 403 Forbidden - user doesn't have permission
      if (status === 403) {
        toastr.error('You do not have permission to access this resource.');
        return Promise.reject(error);
      }

      // Handle 401 Unauthorized - token expired or invalid
      if (status === 401) {
        // TEMPORARY DEBUG: Log instead of redirecting for chatroom requests
        if (error.config?.url?.includes('chatroom')) {
          console.error('=== CHATROOM 401 DEBUG ===');
          console.error('URL:', error.config?.url);
          console.error('Request headers:', error.config?.headers);
          console.error('Authorization header:', error.config?.headers?.Authorization || error.config?.headers?.authorization);
          console.error('Response:', error.response?.data);
          alert('CHATROOM 401 ERROR - Check console for details. Authorization header: ' + (error.config?.headers?.Authorization || error.config?.headers?.authorization || 'MISSING'));
          return Promise.reject(error);
        }

        /*
         * When response code is 401, try to refresh the token.
         * Eject the interceptor so it doesn't loop in case
         * token refresh causes the 401 response
         */
        INSTANCE.interceptors.response.eject(interceptor);

        const refreshToken = localStorage.getItem('refreshToken');
        const user = localStorage.getItem('user');
        const team = localStorage.getItem('team');

        // If we don't have refresh token, clear auth and redirect
        // But DON'T clear localStorage yet - let other requests complete first
        if (!refreshToken || !user) {
          console.error('No refresh token available');
          // Delay clearing to allow in-flight requests to complete
          setTimeout(() => {
            clearAuthAndRedirect('Session expired. Please log in again.');
          }, 100);
          return Promise.reject(error);
        }

        return INSTANCE.post('/v1/authenticate/token', {
          refreshToken,
          user,
          team,
        })
          .then((response) => {
            const newToken = response.data.data.token;
            const newRefreshToken = response.data.data.refreshToken;

            onAccessTokenFetched(newToken, newRefreshToken);

            // Make a fresh request instead of modifying the old config
            // This ensures the request interceptor runs and adds the Authorization header
            const originalConfig = error.response.config;
            console.log('Retrying request with fresh config:', originalConfig.url);

            return INSTANCE({
              method: originalConfig.method,
              url: originalConfig.url,
              data: originalConfig.data,
              params: originalConfig.params,
              // Don't copy headers - let the request interceptor add them
            });
          })
          .catch((refreshError) => {
            console.error('Token refresh failed:', refreshError);
            // Only clear and redirect if refresh fails
            setTimeout(() => {
              clearAuthAndRedirect('Session expired. Please log in again.');
            }, 100);
            return Promise.reject(refreshError);
          })
          .finally(createAxiosResponseInterceptor);
      }

      return Promise.reject(error);
    }
  );
};

createAxiosResponseInterceptor();

export type Subscriber = (access_token: string) => any;

function onAccessTokenFetched(token: string, refreshToken: string) {
  localStorage.setItem('token', token);
  localStorage.setItem('refreshToken', refreshToken);
  console.log('onAccessTokenFetched - Calling subscribers');
  
  // subscribers = subscribers.filter((callback) => callback(token));
}


export function setAxiosHeadersRC(rcToken,rcUserId){
  console.log("rcToken,rcUserId", rcToken,rcUserId)
  INSTANCE.defaults.headers['X-Auth-Token'] = rcToken;
  INSTANCE.defaults.headers['X-User-Id'] = rcUserId;
}
